import './loginError';
import '../_common/services/shared/angulartics-webreporting';
angular.module("iFAST.login", [
    "kendo.directives",
    "iFAST.directive",
    "iFAST.common",
    "ngRoute",
    "ngResource",
    "ngCookies",
    "noCAPTCHA",
    "angulartics",
    "iFAST.angulartics",
    "iFAST.loginError",
    "ui.bootstrap"
]);

angular.module("iFAST.login")
    .config(["$routeProvider", function ($routeProvider) {
        "use strict";
        var loginTemplateURL = require("./login.tpl.html");
        $routeProvider
            .when("/login",
                {
                    templateUrl: loginTemplateURL,
                    controller: "loginCtrl",
                    controllerAs: "loginCtrl"
                })
            .when("/nonclientlogin",
                {
                    templateUrl: loginTemplateURL,
                    controller: "loginCtrl",
                    controllerAs: "loginCtrl"
                })
            .when("/forgotUid",
                {
                    templateUrl: require("./forgotUid.tpl.html"),
                    controller: "forgotUidCtrl",
                    controllerAs: "forgotUidCtrl"
                })
            .when("/forgotPwd",
                {
                    templateUrl: require("./forgotPwd.tpl.html"),
                    controller: "forgotPwdCtrl",
                    controllerAs: "forgotPwdCtrl"
                })
            .when("/changePassword", {
                templateUrl: require("../userAdmin/changePassword.tpl.html"),
                controller: "changePasswordCtrl",
                controllerAs: "changePasswordCtrl"
            })
            .when("/resetPwd", {
                templateUrl: require("./resetPwd.tpl.html"),
                controller: "resetPwdCtrl",
                controllerAs: "resetPwdCtrl"
            })
            .when("/userSelfRegistration",
                {
                    templateUrl: require("./userSelfRegistration.tpl.html"),
                    controller: "userSelfRegistrationCtrl",
                    controllerAs: "userSelfRegistrationCtrl"
                })
            .when("/userInvestorRegistration",
                {
                    templateUrl: require("./userInvestorRegistration.tpl.html"),
                    controller: "userInvestorRegistrationCtrl",
                    controllerAs: "userInvestorRegistrationCtrl"
                })
            .when("/userTypeSelection",
                {
                    templateUrl: require("./userTypeSelection.tpl.html"),
                    controller: "userTypeSelectionCtrl",
                    controllerAs: "userTypeSelectionCtrl"
                })
            .otherwise({
                redirectTo: "/login"
            });

    }]);

angular.module("iFAST.login")
    .run(["$rootScope", "$analytics", "restSvc", "$cookies", function ($rootScope, $analytics, restSvc, $cookies) {
        "use strict";

        //This is a fix for loading client config from main css file.
        var clientCd = "";
        if (location.hostname.indexOf("-") === -1) {
            clientCd = location.hostname.substr(0, location.hostname.indexOf("."));
        } else {
            clientCd = location.hostname.substr(0, location.hostname.indexOf("-"));
        }
        var clientCssUrl = "_assets/css/" + clientCd + ".css";
        /*        var clientLessUrl = "_less/" + clientCd +".properties.less";*/
        $rootScope.stylesheets = [
            { href: clientCssUrl, type: "text/css", rel: "stylesheet" }/*,
            { href: clientLessUrl, type:"text/css", rel:"stylesheet/less"}*/

            //clientLessUrl css doesn't load fast enough before the script loads.
            // instead, using danny's old method for loading local less.prop
        ];

        $rootScope.respondJS = "vendor/respond/src/respond.js";
        $rootScope.userSelectionType = 0;

        if (location.href.indexOf("ifastweb_sp") <= 0) {
            /* user info additional information */
            var userInfoBeforeLoginPromise = restSvc.query({ type: "userservice", method: "userinfobeforelogin" }, {});
            userInfoBeforeLoginPromise.$promise.then(function (result) {
                $analytics.setUserProperties({
                    "sessionid": result.sessionid,
                    /* app.js uses different object name, clientCd. Mapped to be the same. */
                    "clientCd": result.companyid,
                    "slotname": result.slotname,
                    "userid": null,
                    "language": result.language
                });
                $cookies.put('tknlgn', result.tknlgn);
                $rootScope.language = result.language;
            });
        }


    }]);

angular.module("iFAST.login")
    .filter("sceTrustAsHtml", ["$sce", function ($sce) {
        "use strict";
        return function (displayField) {
            return $sce.trustAsHtml(displayField + "");
        };
    }]);

angular.module("iFAST.login")
    .factory("loginLocation", ["$location", "iFastConstants", function ($location) {
        "use strict";

        //handles the cases where absolute url contains "j_security_check".
        var url = function (url) {
            var JSecurityCheck = "j_security_check";
            var absUrl = $location.absUrl();
            if (0 < absUrl.indexOf(JSecurityCheck)) {
                absUrl = absUrl.replace(JSecurityCheck, "");
                var indexOfHash = absUrl.indexOf("#");
                if (0 < indexOfHash) {
                    absUrl = absUrl.substring(0, indexOfHash) + "#";
                }
                location.href = absUrl + url;
            } else {
                $location.url(url);
            }
        };

        //clientCd
        var clientCd = function () {
            var clientCd = "";
            if ($location.host().indexOf("-") === -1) {
                clientCd = $location.host().substr(0, $location.host().indexOf("."));
            } else {
                clientCd = $location.host().substr(0, $location.host().indexOf("-"));
            }

            return clientCd;
        };

        /* add end point to get web reporting
        * /ifastweb20_rest/rest/json/userservice/userinfobeforelogin
         */

        return {
            url: url,
            clientCd: clientCd
        };

    }]);

angular.module("iFAST.common", []);
angular.module("iFAST.filter", []);
//angular.module("iFAST.ssologin", []);

angular.module("iFAST.controller", ["iFAST.service", "iFAST.common"]);
angular.module("iFAST.service", ["ngResource", "iFAST.filter", "iFAST.common"]);
angular.module("iFAST.directive", ["ngAnimate",
    "iFAST.controller",
    "iFAST.service",
    "iFAST.common",
    "kendo.directives",
    "iFAST.filter"]);



// WEBPACK FOOTER //
// ./WebContent/src/login/login.js